function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        ", " {\n          flex-basis: ", "%;\n          max-width: ", "%;\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  box-sizing: border-box;\n  flex: ", ";\n  padding-right: ", "rem;\n  padding-left: ", "rem;\n  flex-grow: ", ";\n  flex-basis: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  flex: ", ";\n  flex-wrap: ", ";\n  margin-right: -", "rem;\n  margin-left: -", "rem;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { Box as GridBox, Flex } from '@rebass/grid';
import styled, { css } from "./..";
import { getValuesWithMediaQueries } from "../../utils";
export var Row = styled(Flex)(_templateObject(), function (props) {
  return props.flex || '0 1 auto';
}, function (props) {
  return props.flexWrap || 'wrap';
}, function (props) {
  return props.theme.gridGap / 2;
}, function (props) {
  return props.theme.gridGap / 2;
}, function (props) {
  return props.height ? "height: ".concat(props.height) : '';
});
export var Column = styled(GridBox)(_templateObject2(), function (props) {
  return props.size && getValuesWithMediaQueries(props.theme, props.size).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        mediaQuery = _ref2[0],
        value = _ref2[1];

    return css(_templateObject3(), mediaQuery, value / props.theme.gridSize * 100, value / props.theme.gridSize * 100);
  });
}, function (props) {
  return props.flex || '0 0 auto';
}, function (props) {
  return props.theme.gridGap / 2;
}, function (props) {
  return props.theme.gridGap / 2;
}, function (props) {
  return props.flexGrow || 1;
}, function (props) {
  return props.flexBasis || 0;
});
export var Box = styled(GridBox)(_templateObject4(), function (props) {
  return !props.noMargin ? "margin-bottom: ".concat(props.theme.gridGap / 2, "rem") : undefined;
});